import http from "../axios";

const couserwareAnalysisApi = {
    getCouserware(data){
        return http({
            url:'/Principal/CourseWare',
            method:'POST',
            data:data
        })
    },
    couserwareDetail(data){
        return http({
            url:'/Principal/CourseWareDetail',
            method:'POST',
            data:data
        })
    }
}

export default couserwareAnalysisApi